import ReactDOM from 'react-dom/client';
import 'driver.js/dist/driver.css';
import App from './App';
import React from 'react';
import { getCompany } from 'helpers/getCompanyVariables';

const company = getCompany();

const link = document.querySelector("link[rel~='icon']");
switch (company) {
  case 'oneill':
    document.title = "O'Neill Portal";
    link.href = '/favicon.ico';
    break;
  case 'sunshine':
    document.title = 'Sunshine Portal';
    link.href = '/faviconSunshine.ico';
    break;
}
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(<App />);
